<template>
  <div class="aside" :style="'width:' + isCollapse ? '64px' : '200px'">
    <div>
      <!-- 侧边栏菜单区 -->
      <el-menu
        ref="elMenu"
        background-color="#333744"
        text-color="#fff"
        unique-opened
        :default-openeds="['通用模块']"
        :collapse="isCollapse"
        :collapse-transition="false"
      >
        <!-- 一级菜单 -->
        <el-submenu
          :index="item.menuName + ''"
          v-for="item in menulist"
          :key="item.menuName + ''"
        >
          <template slot="title">
            <i :class="item.iconFont"></i>
            <span>{{ item.menuName }}</span>
          </template>

          <el-menu-item
            :index="subitem.path"
            v-for="subitem in item.children"
            :key="subitem.path"
            @click="openTab(subitem)"
          >
            <i :class="subitem.iconFont ? subitem.iconFont : 'el-icon-menu'" />
            <span>{{ subitem.menuName }}</span></el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: true
    },
    searchValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // initMenuList: [
      // openAcitveMenu: '',
      // ],
      allMenus: [],
      menulist: [
      ]
    }
  },
  created () {
    this.allMenus = JSON.parse(JSON.stringify(this.$store.state.initMenuList))
    for (let item of this.allMenus) {
      item.children = item.children.filter(itemDetail => {
        return itemDetail.menuName !== '首页'
      })
    }
    this.menulist = this.allMenus
  },
  mounted () {
    // this.openAcitveMenu = this.$store.state.openAcitveMenu
  },
  methods: {
    // 打开路由
    openTab (obj) {
      const PATH = obj.path
      // const openMenusList = JSON.parse(JSON.stringify(this.$store.state.openMenusList))
      // const openMenu = openMenusList.filter(item => {
      //   return item.path === PATH
      // })
      // if (openMenu.length > 0) {
      //   this.$router.push({ name: String(openMenu[0].path).split('/')[1] })
      // } else {
      this.$router.push({ name: String(PATH).split('/')[1] })

      // }
      this.$store.commit('set_open_menu', obj)
    },
    // 搜索菜单
    searchMenu (searchValue) {
      const that = this
      if (searchValue === '') {
        this.menulist = this.allMenus
      } else {
        const cacheArr = [
          {
            iconFont: 'el-icon-search',
            menuName: '搜索结果',
            children: []
          }
        ]
        this.allMenus.forEach(item => {
          item.children.forEach(itemDetail => {
            if (itemDetail.children) {
              itemDetail.children.forEach(menuItem => {
                if (menuItem.menuName.indexOf(searchValue) > -1 || menuItem.pinyin.indexOf?.(searchValue) > -1) {
                  cacheArr[0].children.push(menuItem)
                }
              })
            } else {
              if (itemDetail.menuName.indexOf(searchValue) > -1 || itemDetail.pinyin.indexOf?.(searchValue) > -1) {
                cacheArr[0].children.push(itemDetail)
              }
            }
          })
        })
        // if (cacheArr[0].children.length > 0) {
        this.menulist = cacheArr
        this.$nextTick(() => {
          that.$refs.elMenu.open?.('搜索结果')
        })
        // }
      }
    }
  },
  computed: {
    activeMenu () {
      return this.$store.state.activeMenu
    }
  },
  watch: {
    searchValue: {
      handler (newVal) {
        this.searchMenu(newVal)
      }
    },
    activeMenu: {
      handler (newVal, oldVal) {
        this.$store.commit("set_beforActiveMenu", oldVal)
        if (newVal === '/HomePage' || newVal === '/Home') {
          this.$refs.elMenu.activeIndex = null
        } else {
          this.$refs.elMenu.activeIndex = newVal
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}
/deep/ .el-menu-item {
  padding-left: 35px !important;
}
.toggle-button {
  background-color: #4a5064;
  color: white;
  font-size: 10px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
</style>
